import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createSlots as _createSlots, createElementVNode as _createElementVNode, renderList as _renderList } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("label", null, "Toewijzen aan", -1)

import { ref } from 'vue'
import { surveyStore } from '@/stores/survey'
import SurveyDetailsRow from '@/components/survey/SurveyDetailsRow.vue'
import { SurveyStateLabelColors, SurveyStateLabels } from '@/helpers/surveyStates'
import axios from 'axios'
import { notification } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyDetailsCard',
  setup(__props) {

const loading = ref(false)
const saving = ref(false)
const showScheduledUserModal = ref(false)
const newScheduledUserId = ref<number|null>(null)
const users = ref<{ id:number, full_name:string, active:boolean }[]>([])

function toggleScheduledUserModal () : void {
  showScheduledUserModal.value = !showScheduledUserModal.value
  newScheduledUserId.value = null

  if (showScheduledUserModal.value) {
    getProjectMembers()
  }
}

function getProjectMembers () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/members/' + surveyStore().survey.project_id + '/surveyInspectors').then((r) => {
    users.value = r.data
  }).finally(() => {
    loading.value = false
  })
}

function forwardSurvey () : void {
  saving.value = true
  axios.post(process.env.VUE_APP_API_URL + '/surveys/' + surveyStore().survey.id + '/forward', { userId: newScheduledUserId.value }).then((r) => {
    surveyStore().survey = r.data.data
    notification.success({ message: 'Keuring opnieuw toegewezen.', description: 'De keuring is succesvol toegewezen aan de door u gekozen persoon.' })
    toggleScheduledUserModal()
  }).catch(() => {
    notification.error({ message: 'Fout tijdens opslaan!', description: 'Er is iets mis gegaan. Probeer het nogmaals.' })
  }).finally(() => {
    saving.value = false
  })
}

function filterUsers (input:string, item:{ key:string, value:number }) {
  return item.key.toLowerCase().indexOf(input.toLowerCase()) >= 0
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_card, {
      title: "Details",
      bordered: false
    }, _createSlots({
      default: _withCtx(() => [
        (!_unref(surveyStore)().survey)
          ? (_openBlock(), _createBlock(_component_a_skeleton, {
              key: 0,
              active: ""
            }))
          : (_openBlock(), _createBlock(_component_a_row, {
              key: 1,
              class: "no-mb"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_col, {
                  xs: {span: 24},
                  sm: {span: 24},
                  md: {span: 24},
                  lg: {span: 12}
                }, {
                  default: _withCtx(() => [
                    _createVNode(SurveyDetailsRow, {
                      label: "Project",
                      content: _unref(surveyStore)().survey.project.name
                    }, null, 8, ["content"]),
                    ((_unref(surveyStore)().surveyClosed || !_unref(surveyStore)().isSurveyOwner) && !_unref(surveyStore)().isSpecialInspection)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(SurveyDetailsRow, {
                            label: "Blok",
                            content: _unref(surveyStore)().survey.building_block?.name || '-'
                          }, null, 8, ["content"]),
                          _createVNode(SurveyDetailsRow, {
                            label: "Bouwnummer",
                            content: _unref(surveyStore)().survey.building ? _unref(surveyStore)().survey.building.number_with_address : '-'
                          }, null, 8, ["content"]),
                          _createVNode(SurveyDetailsRow, {
                            label: "Verdieping",
                            content: _unref(surveyStore)().survey.level || '-'
                          }, null, 8, ["content"]),
                          _createVNode(SurveyDetailsRow, {
                            label: "Locatie",
                            content: _unref(surveyStore)().survey.location || '-'
                          }, null, 8, ["content"])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_col, {
                  xs: {span: 24},
                  sm: {span: 24},
                  md: {span: 24},
                  lg: {span: 12}
                }, {
                  default: _withCtx(() => [
                    _createVNode(SurveyDetailsRow, {
                      label: "Ingepland voor",
                      content: _unref(surveyStore)().survey.scheduled_user?.full_name || '-',
                      "show-change-btn": !_unref(surveyStore)().surveyClosed,
                      onButtonClicked: toggleScheduledUserModal
                    }, null, 8, ["content", "show-change-btn"]),
                    _createVNode(SurveyDetailsRow, {
                      label: "Uitvoeren op",
                      content: _unref(surveyStore)().survey.scheduled_at ? new Date(_unref(surveyStore)().survey.scheduled_at).toLocaleString('nl-NL') : '-'
                    }, null, 8, ["content"]),
                    (_unref(surveyStore)().surveyClosed)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(SurveyDetailsRow, {
                            label: "Voltooid door",
                            content: _unref(surveyStore)().survey.completed_by_user?.full_name || '-'
                          }, null, 8, ["content"]),
                          _createVNode(SurveyDetailsRow, {
                            label: "Voltooid op",
                            content: _unref(surveyStore)().survey.completed_at ? new Date(_unref(surveyStore)().survey.completed_at).toLocaleString('nl-NL') : '-'
                          }, null, 8, ["content"])
                        ], 64))
                      : _createCommentVNode("", true),
                    (_unref(surveyStore)().survey.auditor1_user)
                      ? (_openBlock(), _createBlock(SurveyDetailsRow, {
                          key: 1,
                          label: "Auditor 1",
                          content: _unref(surveyStore)().survey.auditor1_user.full_name
                        }, null, 8, ["content"]))
                      : _createCommentVNode("", true),
                    (_unref(surveyStore)().survey.auditor2_user)
                      ? (_openBlock(), _createBlock(SurveyDetailsRow, {
                          key: 2,
                          label: "Auditor 2",
                          content: _unref(surveyStore)().survey.auditor2_user.full_name
                        }, null, 8, ["content"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
      ]),
      _: 2
    }, [
      (_unref(surveyStore)().survey)
        ? {
            name: "extra",
            fn: _withCtx(() => [
              _createVNode(_component_a_tag, {
                color: _unref(SurveyStateLabelColors)[_unref(surveyStore)().survey.status]
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(SurveyStateLabels)[_unref(surveyStore)().survey.status]), 1)
                ]),
                _: 1
              }, 8, ["color"])
            ]),
            key: "0"
          }
        : undefined
    ]), 1024),
    _createVNode(_component_a_modal, {
      title: "Keuring aan iemand anders toewijzen.",
      visible: showScheduledUserModal.value,
      "ok-button-props": { loading: saving.value, disabled: saving.value },
      "ok-text": "Bevestigen",
      onOk: forwardSurvey,
      onCancel: toggleScheduledUserModal
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_row, { class: "no-mb" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _hoisted_1,
                _createVNode(_component_a_select, {
                  placeholder: "Kies persoon",
                  loading: loading.value,
                  filterOption: filterUsers,
                  value: newScheduledUserId.value,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((newScheduledUserId).value = $event)),
                  "show-search": ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (u) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        value: u.id,
                        key: u.full_name,
                        disabled: !u.active || _unref(surveyStore)().survey.scheduled_user_id === u.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(u.full_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value", "disabled"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["loading", "value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "ok-button-props"])
  ], 64))
}
}

})